export type UserMode = 'edit' | 'add';

export const MULTIPLE_ROLES = 'Multiple Roles';
